module.exports = __webpack_public_path__ + "static/img/MV.4b394a84.svg";